import createIcon from '../../createIcon';

/**
 * @component @name FourgPlusMobiledata
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuNSAxMVYxM0gxNC41VjE1SDEwLjVWOUgxNi41QzE2LjUgNy45IDE1LjYgNyAxNC41IDdIMTAuNUM5LjQgNyA4LjUgNy45IDguNSA5VjE1QzguNSAxNi4xIDkuNCAxNyAxMC41IDE3SDE0LjVDMTUuNiAxNyAxNi41IDE2LjEgMTYuNSAxNVYxMUgxMi41Wk0yMy41IDExSDIxLjVWOUgxOS41VjExSDE3LjVWMTNIMTkuNVYxNUgyMS41VjEzSDIzLjVWMTFaTTYuNSA3SDQuNVYxMkgyLjVWN0gwLjVWMTRINC41VjE3SDYuNVYxNEg3LjVWMTJINi41VjdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FourgPlusMobiledata = createIcon('FourgPlusMobiledata', [
  [
    'path',
    {
      d: 'M12.5 11V13H14.5V15H10.5V9H16.5C16.5 7.9 15.6 7 14.5 7H10.5C9.4 7 8.5 7.9 8.5 9V15C8.5 16.1 9.4 17 10.5 17H14.5C15.6 17 16.5 16.1 16.5 15V11H12.5ZM23.5 11H21.5V9H19.5V11H17.5V13H19.5V15H21.5V13H23.5V11ZM6.5 7H4.5V12H2.5V7H0.5V14H4.5V17H6.5V14H7.5V12H6.5V7Z',
      key: '1spvlg',
    },
  ],
]);

export default FourgPlusMobiledata;
